exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* purgecss start ignore */\n#tidio-chat-iframe {\n  bottom: 1.8rem !important;\n}\n@media only screen and (max-width: 600px) {\n#tidio-chat-iframe {\n    bottom: 3rem !important;\n}\n}\n\n/* purgecss end ignore */\n", ""]);
